/**
 * Discriminator for rows in `EpcScheduleSnapshot.canonicalPayload.tasks`.
 * Keeps MPP-derived schedule lines distinct from OMS/AMS operational task models in DB and validation.
 */
export const EPC_SCHEDULE_TASK_ENTITY = 'epcScheduleTask' as const;

/**
 * One row from an EPC schedule snapshot (MPP / editor / API).
 * Optional fields link rows to the EPC project org chart (Team & hierarchy) and execution owner.
 */
export type EpcScheduleTaskRow = Record<string, unknown> & {
  /** Project org unit id (`EpcProjectOrgUnit`) — department bucket for the task. */
  epcOrgUnitId?: string;
  /** User id — usually a manager or site engineer in that department; head is set on the team, not here. */
  assignedUserId?: string;
};
